module.exports = __webpack_public_path__ + "img/icon-arrow-right.ff1b0a1a.svg";